import WorkingLocationComponent from "../components/WorkingLocation";
import useWorkingLocation from "../hooks/useWorkingLocation";

function WorkingLocation(props) {
  const useWorkingLocationProps = useWorkingLocation(props);
  return <WorkingLocationComponent {...useWorkingLocationProps} />;
}

export default WorkingLocation;
